import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import moment from "moment/moment";
import SelectDropdown from "../../components-react/SelectDropdown";
import { fetchGymData } from "../../../data/APIs";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import LastMonthCTOdetails from "../settlement-cto/LastMonthCTOdetails";
import FormHeading from "../common/FormHeading";
import {
  selectSettlementFormValues,
  setClickedRowValue,
  updateSettlementFormValues,
} from "../../../redux/reducers/settlementFormSlice";
import {
  fetchCTOData,
  fetchCreateNewSettlementData,
  fetchSettlementData,
} from "../../../redux/reducers/apiSlice";
import { toast } from "react-toastify";
import { selectAuth } from "../../auth/auth.selector";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
// import AddButton from '../common/AddButton';
// import { Container, Row, Col } from 'react-bootstrap';
// import ModalHeadAndClose from '../common/ModalHeadAndClose';

function CreateNewSettlement() {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const navigate = useNavigate();
  const gymData = useSelector(selectGymData);
  const settlementFormValuesNew = useSelector(selectSettlementFormValues);
  const { ctoData, searchedSettlementData, settlementData, loading, error } =
    useSelector((state) => state.api);
  const selectedGym = useSelector((state) => state.filters.selectedGym);

  const isSettlementSystem =
    window.location.pathname.includes("settlement-system");
  const today = new Date().toISOString().split("T")[0];

  // const initialSettlementFormValues = {
  //     selectedYear: new Date().getFullYear().toString(),
  //     selectedGym: "",
  //     selectedSettlementStartDate: "",
  //     selectedSettlementEndDate: "",
  // }
  // const [settlementFormValues, setSettlementFormValues] = useState(initialSettlementFormValues);
  const [lastMonthCtoDetailsModal, setLastMonthCtoDetailsModal] =
    useState(false);
  const [allSearchedSettlementData, setAllSearchedSettlementData] = useState(
    []
  );
  const [recentSettlementDetails, setRecentSettlementDetails] = useState([]);
  const [searchDetailsSubmit, setSearchDetailsSubmit] = useState(false);

  const endDate = new Date(settlementFormValuesNew.selectedSettlementEndDate);
  const endMonth = endDate.getMonth() + 1;

  const selectedGymQueryParam = selectedGym
    ? `&gym_id=${selectedGym?.value}`
    : settlementFormValuesNew.selectedGym
    ? `&gym_id=${settlementFormValuesNew.selectedGym?.value}`
    : "";
  const selectedYearParam = settlementFormValuesNew.selectedYear
    ? `&year=${settlementFormValuesNew.selectedYear}`
    : "";
  const startDateQueryParam =
    settlementFormValuesNew.selectedSettlementStartDate
      ? `&from_date=${settlementFormValuesNew.selectedSettlementStartDate}`
      : "";
  const endDateQueryParam = settlementFormValuesNew.selectedSettlementEndDate
    ? `&to_date=${settlementFormValuesNew.selectedSettlementEndDate}`
    : "";
  const queryParameters = `${selectedGymQueryParam}${selectedYearParam}${startDateQueryParam}${endDateQueryParam}`;

  const monthQueryParam = endMonth ? `&month=${endMonth}` : "";
  const queryParametersForCTO = `${selectedGymQueryParam}${selectedYearParam}${monthQueryParam}`;

  const onChangeHandle = (fieldName, selectedValue) => {
    // setSettlementFormValues((prevState) => ({
    //     ...prevState,
    //     [fieldName]: selectedValue,
    // }));

    dispatch(updateSettlementFormValues({ [fieldName]: selectedValue }));
  };

  const labelStyle = {
    color: isSettlementSystem ? "#FFFFFF" : "#151515",
  };

  const onClickSearchDetails = (e) => {
    e.preventDefault();

    const startDate = new Date(
      settlementFormValuesNew?.selectedSettlementStartDate
    );
    const endDate = new Date(
      settlementFormValuesNew?.selectedSettlementEndDate
    );
    const currentDate = new Date();

    if (!selectedGym && !settlementFormValuesNew?.selectedGym) {
      toast.error("Please Select Gym!");
      return;
    }

    // if (
    //   !startDate ||
    // startDate <= new Date(recentSettlementDetails?.date_to) ||
    //   startDate.getMonth() !== currentDate.getMonth() ||
    //   startDate.getFullYear() !== currentDate.getFullYear()
    // ) {
    //   toast.error(
    //     "Start date must be after the most recent settlement end date."
    //   );
    //   return;
    // }
    // if (
    //   !endDate ||
    //   endDate.getMonth() !== currentDate.getMonth() ||
    //   endDate.getFullYear() !== currentDate.getFullYear() ||
    //   !endDate ||
    //   endDate <= new Date(recentSettlementDetails?.date_to)
    // ) {
    //   toast.error("Start date must be from the current month.");
    //   return;
    // }
    // if (settlementFormValuesNew?.is_approved === 0) {
    //   toast.error("Last Settlement Is Pending!");
    //   return;
    // }

    if (!startDate) {
      toast.error("Start date is required!");
      return;
    } else if (
      startDate &&
      recentSettlementDetails?.date_to &&
      startDate <= new Date(recentSettlementDetails?.date_to)
    ) {
      toast.error(
        "Start date must be after the most recent settlement end date!"
      );
      return;
    }

    if (
      !endDate ||
      !endDate ||
      endDate <= new Date(recentSettlementDetails?.date_to)
    ) {
      toast.error("End date is required!");
      return;
    } else if (
      endDate &&
      recentSettlementDetails?.date_to &&
      endDate <= new Date(recentSettlementDetails?.date_to)
    ) {
      toast.error("End date must be after the last settlement month!");
      return;
    }

    if (settlementFormValuesNew?.is_approved === 0) {
      toast.error("Last Settlement Is Pending!");
      return;
    }

    dispatch(
      fetchCTOData({
        queryParameters: queryParametersForCTO,
        token: decryptedText?.token,
      })
    );
    setSearchDetailsSubmit(true);
  };

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, [dispatch]);

  useEffect(() => {
    if (ctoData?.status && ctoData?.data?.length > 0) {
      dispatch(
        fetchCreateNewSettlementData({
          queryParameters,
          token: decryptedText?.token,
        })
      );
    } else if (searchDetailsSubmit) {
      setLastMonthCtoDetailsModal(true);
    }
  }, [ctoData]);

  useEffect(() => {
    if (searchedSettlementData?.status && searchedSettlementData?.data) {
      setAllSearchedSettlementData(searchedSettlementData.data);
      dispatch(setClickedRowValue(searchedSettlementData));

      if (
        settlementFormValuesNew.selectedYear &&
        settlementFormValuesNew.selectedGym &&
        settlementFormValuesNew.selectedSettlementStartDate &&
        settlementFormValuesNew.selectedSettlementEndDate
      ) {
        navigate("/settlement-system");
      }
    } else if (searchDetailsSubmit && !searchedSettlementData?.status) {
      // setLastMonthCtoDetailsModal(true);
      toast.error(searchedSettlementData?.message);
    }
  }, [searchedSettlementData]);

  useEffect(() => {
    if (settlementFormValuesNew.selectedGym) {
      dispatch(
        fetchSettlementData({
          queryParameters: selectedGymQueryParam,
          token: decryptedText?.token,
        })
      );
    }
  }, [settlementFormValuesNew.selectedGym]);

  useEffect(() => {
    if (settlementData?.status && settlementData?.data) {
      setRecentSettlementDetails(settlementData.data?.[0]);
    }
  }, [settlementData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  // useEffect(() => {
  //     if (recentSettlementDetails && recentSettlementDetails?.date_to) {
  //         const endDate = new Date(recentSettlementDetails.date_to);

  //         console.log(endDate);

  //         const currentYear = endDate?.getFullYear();
  //         const currentMonth = endDate?.getMonth() + 1;
  //         const currentDay = endDate?.getDate();

  //         const nextDay = new Date(currentYear, currentMonth - 1, currentDay + 1);
  //         setMinStartDate(moment(formatDate(nextDay)).format('DD-MM-YYYY'));
  //         setMaxStartDate(moment(formatDate(endDate)).format('DD-MM-YYYY'));
  //         setMinEndDate(moment(formatDate(nextDay)).format('DD-MM-YYYY'));

  //         const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
  //         const nextYear = currentMonth === 12 ? currentYear + 1 : currentYear;
  //         const lastDayOfNextMonth = new Date(nextYear, nextMonth, 0).getDate();
  //         console.log("lastDayOfNextMonth ", lastDayOfNextMonth);
  //         setMaxEndDate(moment(`${nextYear}-${nextMonth.toString().padStart(2, '0')}-${lastDayOfNextMonth.toString().padStart(2, '0')}`).format('DD-MM-YYYY'));
  //     }
  // }, [recentSettlementDetails.date_to]);

  // const formatDate = (date) => {
  //     const year = date.getFullYear();
  //     const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //     const day = date.getDate().toString().padStart(2, '0');
  //     return `${year}-${month}-${day}`;
  // };

  // console.log("searchedSettlementData=> ", searchedSettlementData);
  // console.log("recentSettlementDetails***=> ", recentSettlementDetails);

  //   console.log("recentSettlementDetails> ", recentSettlementDetails);

  return (
    <>
      <Modal
        isOpen={lastMonthCtoDetailsModal}
        onRequestClose={() => setLastMonthCtoDetailsModal(false)}
        contentLabel="Settlement Modal"
        ariaHideApp={false}
      >
        <LastMonthCTOdetails
          selectedGym={settlementFormValuesNew?.selectedGym}
          onClose={() => setLastMonthCtoDetailsModal(false)}
        />
      </Modal>

      <form className="formContainer settleForm">
        <FormHeading title="Create New Settlement" labelStyle={labelStyle} />

        {!isSettlementSystem && settlementFormValuesNew.selectedGym && (
          <p className="recentSettlementDetails">
            Recent Settlement{" "}
            <span className="badge bg-danger text-white">
              {recentSettlementDetails?.date_from
                ? moment(recentSettlementDetails?.date_from)
                    .tz("Asia/Kolkata")
                    .format("DD-MM-YYYY")
                : "-"}
            </span>{" "}
            TO{" "}
            <span className="badge bg-danger text-white">
              {recentSettlementDetails?.date_to
                ? moment(recentSettlementDetails?.date_to)
                    .tz("Asia/Kolkata")
                    .format("DD-MM-YYYY")
                : "-"}
            </span>
          </p>
        )}

        <div className="formInputs">
          <div className="formRow">
            <div className="formRowField">
              <label
                htmlFor="year"
                className="formRowFieldLabel"
                style={labelStyle}
              >
                Select Year
              </label>

              <input
                type="text"
                value={settlementFormValuesNew.selectedYear}
                className="formInput"
                disabled
              />
            </div>

            {!selectedGym?.value && (
              <div className="formRowField">
                <label
                  htmlFor="gym"
                  className="formRowFieldLabel"
                  style={labelStyle}
                >
                  Select Gym
                </label>

                <SelectDropdown
                  options={gymData}
                  selectedOption={settlementFormValuesNew.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    onChangeHandle("selectedGym", selectedValue)
                  }
                  name="Gym From The List"
                />
              </div>
            )}
          </div>

          <div className="formRow">
            <div className="formRowField">
              <label
                htmlFor="year"
                className="formRowFieldLabel"
                style={labelStyle}
              >
                Select Settlement Duration (Start Date)
              </label>

              <input
                type="date"
                placeholder="Start Date"
                className="formInput"
                value={settlementFormValuesNew.selectedSettlementStartDate}
                onChange={(e) =>
                  onChangeHandle("selectedSettlementStartDate", e.target.value)
                }
                max={today}
              />
            </div>

            <div className="formRowField">
              <label
                htmlFor="gym"
                className="formRowFieldLabel"
                style={labelStyle}
              >
                Select Settlement Duration (End Date)
              </label>

              <input
                type="date"
                placeholder="End date"
                className="formInput"
                value={settlementFormValuesNew.selectedSettlementEndDate}
                onChange={(e) =>
                  onChangeHandle("selectedSettlementEndDate", e.target.value)
                }
                max={today}
              />
            </div>
          </div>
        </div>

        <div className="formButtonContainer">
          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <Button
              variant="danger"
              onClick={onClickSearchDetails}
              style={{ padding: "20px" }}
            >
              Search details
            </Button>
          )}
        </div>
      </form>
    </>
  );
}

export default CreateNewSettlement;
